import { Tag, Input, Space, Table, TableProps, Checkbox, DatePicker, TimePicker } from "antd";
import TextArea from "antd/es/input/TextArea";

import React, { useEffect, useRef, useState } from 'react';
import { CalendarOutlined, ClockCircleOutlined, InboxOutlined, UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Button, message, Upload } from 'antd';
import { CustomAxios } from "../../services/api";
import Dragger from "antd/es/upload/Dragger";
import MessageListPopUp from "./message.list.modal";
import dayjs, { Dayjs } from "dayjs";

interface TagPopUpProps {
    agentSeq?: any;
    clubSeq?: any;
    selectedRecord: any;
    tagAry: string[];
    messagetitle: any;
    memberIdAllAry: string[];
    memberIdSearchAry: string[];
    memberIdSelectedAry: string[];
    sendType: string;
}

const MessageAllPopUp: React.FC<TagPopUpProps> = ({ selectedRecord, tagAry, agentSeq, clubSeq, messagetitle, memberIdAllAry, memberIdSearchAry, memberIdSelectedAry, sendType }) => {
    console.log(">>>>>>>>>>> sendType: ", sendType);

    const [sendMemberId, setSendMemberId] = useState<string[]>([]);
    const [Qrlasttimetime, setQrlasttimetime] = useState('');
    const [isreservation, setisreservation] = useState(false);
    const [reservedDate, setreservedDate] = useState<Dayjs | null>(null);

    const [schedulerdate, setschedulerdate] = useState<Dayjs | null>(null);
    const [reservationTime, setReservationTime] = useState<Dayjs | null>(null);


    const [modalTitle, setModalTitle] = useState<any>("1:N 메시지발송");

    useEffect(() => {
        if (sendType === "all") {
            setSendMemberId(memberIdAllAry);
        } else if (sendType === "search") {
            setSendMemberId(memberIdSearchAry);
        } else if (sendType === "selected") {
            setSendMemberId(memberIdSelectedAry);
        }
        setRefresh(Date.now());
    }, [sendType, memberIdAllAry, memberIdSearchAry, memberIdSelectedAry]);

    const [textAreaValue, setTextAreaValue] = useState<string>('');
    const [fileList, setFileList] = useState<any[]>([]);

    const props: UploadProps = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            setFileList([...fileList, file]);

            return false;
        },
        fileList,
    };

    const isreservationChange = () => {
        setisreservation(!isreservation);
    };

    const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setTextAreaValue(e.target.value);
    };

    const handleFileChange = ({ fileList }: { fileList: any[] }) => {
        setFileList(fileList);
    };

    const handleSendMessage = () => {
        console.log('TextArea 값:', messagetitle);
        console.log('MessageTitle 값:', textAreaValue);
        console.log('파일 정보:', fileList);
        console.log('clubSeq:', clubSeq);
        console.log('selectedRecord?.memberId:', selectedRecord?.memberId);
        if (isreservation) {
            console.log("예약메시지")

            const formData = new FormData();
            if (fileList.length > 0 && fileList[0]?.originFileObj) {
                // 파일이 있을 때 파일을 추가
            } else {
                // 파일이 없을 때 빈 파일 추가
                const emptyFile = new Blob([], { type: "application/octet-stream" });
                formData.append("files", emptyFile, "empty_file.txt");
            }
    
            fileList.forEach(file => {
                formData.append("files", file.originFileObj);
            });
            console.log("보내는시간 : " + reservedDate)
            if(reservedDate==null){
                message.error("예약시간을 입력해주세요.");
            }else{
    
                const jsonData: any = {
                    clubSeq: clubSeq,
                    title: modalTitle,
                    message: textAreaValue,
                    memberAll:false,
                    receiverMemberId: sendMemberId,
                    reservedDate:reservedDate
                };
        
                if (isreservation) {
                    jsonData.reservedDate = reservedDate?.format('YYYY-MM-DD HH:mm:ss');
                }
                console.log("보내는값 : " + JSON.stringify(jsonData,null,2))
        
                const blob = new Blob([JSON.stringify(jsonData)], {
                    type: "application/json",
                });
        
                formData.append("messageSchedulerDto", blob);
        
                CustomAxios.postPersonalMessageCreateScheduler(formData)
                    .then((response: any) => {
                        console.log("postStudyCreateFile", response);
                        setFileList([]);
                        setTextAreaValue("");
                        setModalTitle("");
                        message.info('예약 메시지가 등록되었습니다.');
                        setRefresh(Date.now());
                    })
                    .catch((err: any) => {
                        console.log("postStudyCreateFile error", err);
                    });
            }

        }else{
            console.log("일반메시지")
            const formData = new FormData();
            if (fileList.length > 0 && fileList[0]?.originFileObj) {
                // 파일이 있을 때 파일을 추가
                //formData.append("files", fileList[0].originFileObj);
            } else {
                // 파일이 없을 때 빈 파일 추가
                const emptyFile = new Blob([], { type: "application/octet-stream" });
                formData.append("files", emptyFile, "empty_file.txt");
            }
    
            fileList.forEach(file => {
                formData.append("files", file.originFileObj);
            });
    
            const jsonData = {
                clubSeq: clubSeq,
                title: modalTitle,
                message: textAreaValue,
                receiverMemberId: sendMemberId
            };
            const blob = new Blob([JSON.stringify(jsonData)], {
                type: "application/json",
            });
    
            formData.append("personalMessageDto", blob);

            console.log("일반메시지")
            CustomAxios.postPersonalMessageCreate(formData)
                .then((response: any) => {
                    console.log("postStudyCreateFile", response);
                    setFileList([]);
                    setTextAreaValue("");
                    setModalTitle("");
                    message.info('메시지가 전송되었습니다.');
                    setRefresh(Date.now());
                })
                .catch((err: any) => {
                    console.log("postStudyCreateFile error", err);
                });
        }





        }

        const titlehandleInputChange = (event: any) => {
            setModalTitle(event.target.value); // 입력된 값을 modalTitle 상태에 설정
        };
    const handleDateChange = (date: Dayjs | null) => {
        setschedulerdate(date);
        if (date && reservationTime) {
            const combinedDateTime = date.clone().hour(reservationTime.hour()).minute(reservationTime.minute());
            setreservedDate(combinedDateTime);
        }
    };

    const handleTimeChange = (time: Dayjs | null) => {
        setReservationTime(time);
        if (time && schedulerdate) {
            const combinedDateTime = schedulerdate.clone().hour(time.hour()).minute(time.minute());
            setreservedDate(combinedDateTime);
        }
    };

    const timestamp = Date.now();
    const [refresh, setRefresh] = useState(timestamp);

    return (
        <div style={{ height: '900px', overflowY: 'auto' }}>
            <div> <Input type="text" id="modalTitleInput" value={modalTitle} onChange={titlehandleInputChange} placeholder="메세지제목" />
                </div>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                
                <TextArea rows={20} placeholder="메시지작성" value={textAreaValue} onChange={handleTextAreaChange} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: 10, marginBottom: 10 }}>
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                    <Dragger {...props}
                        style={{ width: '100%' }}
                        fileList={fileList}
                        onChange={handleFileChange}
                        multiple={true}
                    >
                        <p className="ant-upload-text"><InboxOutlined /> Click or drag file to this area to upload</p>
                    </Dragger>
                </div>
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                    <Checkbox style={{ marginRight: '20px', width: "150px" }} onClick={isreservationChange}>예약 메시지</Checkbox>
                    <Button type="primary" style={{ width: '100%' }} icon={<UploadOutlined />} onClick={handleSendMessage}>메시지전송</Button>
                </div>
            </div>
            {isreservation && (
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                        <CalendarOutlined style={{ marginRight: '8px', fontSize: '18px', color: '#1890ff' }} />
                        <span style={{ marginRight: '8px', fontWeight: 'bold' }}>발송일</span>
                        <DatePicker
                            clearIcon
                            style={{ width: '200px' }}
                            placeholder="날짜 선택"
                            value={schedulerdate}
                            onChange={handleDateChange}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ClockCircleOutlined style={{ marginRight: '8px', fontSize: '18px', color: '#1890ff' }} />
                        <span style={{ marginRight: '8px', fontWeight: 'bold' }}>예약시간</span>
                        <TimePicker
                            changeOnBlur
                            style={{ width: '200px' }}
                            placeholder="시간 선택"
                            value={reservationTime}
                            format="HH:mm"
                            onChange={handleTimeChange}
                        />
                    </div>
                </div>
            )}
            <div><Space>메시지 전송할 대상 : {sendMemberId.length}명이 선택되었습니다. </Space></div>
            <MessageListPopUp refresh={refresh} selectedRecord={selectedRecord} agentSeq={agentSeq} clubSeq={clubSeq}></MessageListPopUp>
        </div>
    );
}
export default MessageAllPopUp;
